import React, { useState, useEffect } from 'react';
import ErrorBoundary from '../../../../../error/error.component';
import FallbackUI from '../../../../../error/standardFallback.component';
import { FadeIn } from '../../../../../styled/fadeIn.component';
import { Icon } from '../../../../../styled/icon.component';
import Language from '../../../../../../constants/language';
import TextInput from '../../../../../textInput.component';
import { InputError } from '../../../../../styled/inputError.component';
import { isNullOrUndefined } from '../../../../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { setProductSetupWizard } from '../../../../../../reducers/slices/productSetupWizard.slice';
import { useProductTypeSetupWizard } from '../../../../../../factories/productSetup.factory';

function MaxNumberProductsInShippingPrice(props) {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user.value);
    const language = useSelector((state) => state.language.value);
    const currentLandingPage = useSelector((state) => state.currentLandingPage.value);
    const productSetupWizard = useSelector((state) => state.productSetupWizard.value);

    const [maxNumberOfProductsInShippingPrice, setMaxNumberOfProductsInShippingPrice] = useState(isNullOrUndefined(productSetupWizard.product?.maximum_number_of_products_in_shipping_price) ? '1' : productSetupWizard.product.maximum_number_of_products_in_shipping_price);
    const [additionalClasses, setAdditionalClasses] = useState('');
    const [error, setError] = useState(null);

    const { updateProduct } = useProductTypeSetupWizard();
    
    function checkMaxNumberOfProductsInShippingPrice(event, action = 'submit') {
        let newValue = event.target.value;
        let isValid = false;
        if(newValue.trim().length > 0 && parseInt(newValue) !== NaN && parseInt(newValue) > 0) {
            isValid = true;
        }
        if(isValid) {
            setAdditionalClasses('');
            setError(null);
        }
        else {
            setAdditionalClasses('is-invalid');
            setError(Language[language].shop.wizard.product.valueIsInvalid);
        }
        let product = _.cloneDeep(productSetupWizard.product);
        product = updateProduct(product, { type: 'maximum_number_of_products_in_shipping_price', value: newValue });
        let updatedWizard = { step: productSetupWizard.step, product: product};
        if(isValid && action === 'submit') {
            updatedWizard.step++;
        }
        dispatch(setProductSetupWizard(updatedWizard));
        setMaxNumberOfProductsInShippingPrice(newValue);
    }

    return (
        <FadeIn>
            <div className="row">
                <div className="col d-flex justify-content-center align-items-center">
                    { Language[language].shop.wizard.product.enterMaxNumberOfProductsInOneShippingPackage }
                </div>
            </div>
            <div className="row mt-2">
                <div className="col">
                    <TextInput
                        key={"maxNumberOfProductsInShippingPrice"}
                        type={"number"}
                        step={"1"}
                        min={"1"}
                        label={""}
                        value={maxNumberOfProductsInShippingPrice}
                        name={"maxNumberOfProductsInShippingPrice"}
                        placeholder={Language[language].shop.wizard.product.maxNumberOfProductsInOneShippingPackage}
                        onChange={(event) => checkMaxNumberOfProductsInShippingPrice(event, 'change')}
                        submitOnEnter={true}
                        submitEvent={(event) => checkMaxNumberOfProductsInShippingPrice(event)}
                        required={true}
                        maxLength={255}
                        autoFocus={true}
                        additionalClasses={additionalClasses}
                    />
                    {
                        error !== null &&
                        <InputError>
                            {
                                error
                            }
                        </InputError>
                    }
                </div>
            </div>
        </FadeIn>
    );
}

const ComponentWithErrorBoundary = (props) => {
    const language = useSelector((state) => state.language.value);
    return ( 
        <ErrorBoundary
            location={"builder"}
            component={"maxNumberProductsInShippingPrice.component.js"}
            fallbackUI={<FallbackUI language={language} component={"maxNumberProductsInShippingPrice"} />}
        >
            <MaxNumberProductsInShippingPrice
                key={`maxNumberProductsInShippingPriceComponent`}
                {...props}
            />
       </ErrorBoundary>
   )
}
 
export default ComponentWithErrorBoundary;